import React from 'react';
import './styles.scss';


class PopupNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message : '',
            show : false,
            isCheck :false
        }
    }

    componentDidMount() {
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps.isReciveProps) {
            this.setState({
                message : nextProps.message || '成功',
                show : nextProps.show,
            });
        }
            
        this.commonHideComponent('wrap-modal-message', 'modal-message');        
    }


    commonHideComponent = (p, c) => {
        const wrapWorkspace = document.getElementById(p);
        const workspace = document.getElementById(c);
        if (wrapWorkspace) {
            
        let self = this;
        wrapWorkspace.addEventListener('click', function (event) {
            const isClickInside = workspace.contains(event.target);
            if (!isClickInside) {
                self.setState({
                    show : false,
                    message: ''
                })
                self.props.setIsReciveProps();
            }
        });
        }
    }

    closeModalMessage = () => {
        this.setState({ 
            show  :false,
            message: ''
         });
         this.props.setIsReciveProps();
    }

    render() {
        return (
            this.state.show
                ? 
                <div className="modal-message" id="wrap-modal-message">
                    <div className="modal" id='modal-message'>
                        <h4>お知らせ</h4>
                        <h6>{this.state.message }</h6>
                        <div className="group-btn-add">
                            <button onClick={() => this.closeModalMessage()}>閉じる</button>
                        </div>
                    </div>
                </div>
                : null
            
        );
    }
}
export default PopupNotification;